export const imageKeys = {
  mobile375x110: [
    "375x110",
    "375x111",
    "376x110",
    "750x220",
    "750x221",
    "751x220",
    "752x220",
    "750x276",
  ],
  mobile375x258: ["375x258", "375x259", "376x258", "750x516", "752x516"],
  tablet532x110: ["532x110", "532x111", "533x110", "1064x220", "1064x276"],
  tablet724x110: ["724x110", "724x111", "725x110", "1448x220", "1448x276"],
  desktop918x110: ["918x110", "919x111", "1836x220", "1836x276"],
  widedesktop984x120: ["984x120", "1968x240"],
  widedesktop1486x120: ["1486x120", "2972x240"],
  widedesktop1486x180: ["1486x180", "2972x360"],
  buylistHeader: ["900x254", "1800x508", "1350x381", "1184x333"],
};

export const bannerPresets = {
  adNumber: "",
  advertiser: "",
  advertiserId: "",
  alt: "",
  bannerTitle: "",
  bannerType: "brand",
  bannerURL: "",
  bespokeTemplate: true,
  buylistHeader: {
    name: "",
    path: "",
    size: "1184x333",
  },
  currentUser: false,
  desktop918x110: {
    name: "LIPTON_ICED_TEA_BV_LegoBrand_918x110@2x.jpg",
    path: "https://firebasestorage.googleapis.com/v0/b/ghs-trade-banners.appspot.com/o/images%2Fbrand-template%2F1568219176979-LIPTON_ICED_TEA_BV_LegoBrand_918x110%402x.jpg?alt=media&token=0f6f945e-1633-48ce-abe4-ff376ff0f119",
    size: "1836x220",
  },
  hideMPU: "no",
  informationBanner: "no",
  key: "",
  lastModAt: "",
  lastModBy: "",
  mobile375x110: {
    name: "",
    path: "",
    size: "750x220",
  },
  mobile375x258: {
    name: "",
    path: "",
    size: "750x516",
  },
  openLinkOptions: "_top",
  retailer: "tesco",
  status: 2,
  tablet532x110: {
    name: "",
    path: "",
    size: "1064x220",
  },
  tablet724x110: {
    name: "",
    path: "",
    size: "1448x220",
  },
  templateId: "11747076",
  tescoEvent: "",
  userId: "",
};
